// This code was adapted from https://github.com/mui-org/material-ui/pull/20407
// There's no immediate plans for MUI to make this hook part of their public API
// so we can just use a local copy for now.
import { useEffect, useState } from 'react';
export default function useId(idOverride) {
  var _useState = useState(idOverride),
      defaultId = _useState[0],
      setDefaultId = _useState[1];

  var id = idOverride || defaultId;
  useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("jpmui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}
//# sourceMappingURL=useId.js.map